import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { useRootStore } from 'stores/RootStore'
import { useLocation } from 'react-router-dom'
import { useCallback } from 'react'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { VirtualMarketerClient } from 'api/clients/VirtualMarketerClient'

export const useChooseOnboardingPlan = () => {
  const location = useLocation()
  const workspace = useCurrentWorkspace()
  const { tierUsageStore } = useRootStore()
  const isGrowth = location.search.includes('campaigns=true')

  const saveSubscriptionPlan = useCallback(async () => {
    if (!workspace) return

    const targetPlanKey = isGrowth ? PaymentPlanKey.BlazeAutopilotGrowth : PaymentPlanKey.BlazeAutopilotStarter

    if (!tierUsageStore.initialized) {
      await tierUsageStore.fetch(workspace.id)
    }

    if (tierUsageStore.currentSubscription?.plan === targetPlanKey) return

    if (tierUsageStore.autopilotPlans.length === 0) {
      await tierUsageStore.fetch(workspace.id)
    }

    const monthlyPrice = tierUsageStore.autopilotPlans
      .find((p) => p.key === targetPlanKey)
      ?.prices?.find((p) => p.recurring.interval_count === 1)

    if (!monthlyPrice?.id) return

    const res = await VirtualMarketerClient.updateSubscription(workspace.id, {
      price_id: monthlyPrice.id,
      should_end_trial: false,
    })

    if (res.type !== SUCCESS_RESPONSE_TYPE) return

    await tierUsageStore.fetch(workspace.id)
  }, [isGrowth, workspace, tierUsageStore])

  return { saveSubscriptionPlan }
}
